import React from "react";
import { useTranslation } from "react-i18next";

const ClaimInfo = ({ ifastOrder }) => {
  const { t } = useTranslation();

  // Get the last object from the jeeblyOrder array
  const latestUpdate = ifastOrder?.logisticPartnerMetadata?.IFAST?.getDeliveryInfo || null;
    

  return (
    <div>
      <table className="border-collapse border border-slate-400 w-full mt-4">
        {latestUpdate && (
          <>
            <tr>
              <td className="border border-slate-300 p-4">{t("status")}</td>
              <td className="border border-slate-300 p-4">
                <div>{latestUpdate.status}</div>

              </td>
            </tr>

            {/* {latestUpdate.trackingUrl && (
              <tr>
                <td className="border border-slate-300 p-4">{t("Tracking Url")}</td>
                <td className="border border-slate-300 p-4">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={latestUpdate.trackingUrl}
                    className="underline text-blue-500"
                  >
                    {latestUpdate.trackingUrl}
                  </a>
                </td>
              </tr>
            )} */}

            {(latestUpdate.driver_name || latestUpdate.driver_phone_number) && (
              <>
                {latestUpdate.rider_name && (
                  <tr>
                    <td className="border border-slate-300 pl-4 border-b-0">Delivery Guy</td>
                    <td className="border border-slate-300 p-4">
                      <div><strong>Name:</strong></div>
                      <div>{latestUpdate.driver_name}</div>
                    </td>
                  </tr>
                )}
                {latestUpdate.driver_phone_number && (
                  <tr>
                    <td></td>
                    <td className="border border-slate-300 p-4">
                      <div><strong>Phone:</strong></div>
                      <div>{latestUpdate.driver_phone_number}</div>
                    </td>
                  </tr>
                )}
              </>
            )}
          </>
        )}
      </table>
    </div>
  );
};

export default ClaimInfo;
